var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoginPrompt)?_c('p',[_vm._v("\n    Already a member of artguide? Sign in\n    "),_c('span',{staticClass:"guide__participate-login-prompt",on:{"click":_vm.onPromptClick}},[_vm._v("here")]),_vm._v(".\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }